import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { trialStatusText } from '@/config/dic';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import VideoIframe from './VideoIframe.vue';

var TrialInfo = /*#__PURE__*/function (_Vue) {
  _inherits(TrialInfo, _Vue);

  var _super = _createSuper(TrialInfo);

  function TrialInfo() {
    _classCallCheck(this, TrialInfo);

    return _super.apply(this, arguments);
  }

  _createClass(TrialInfo, [{
    key: "trialStatusText",
    get: function get() {
      return trialStatusText;
    }
  }]);

  return TrialInfo;
}(Vue);

__decorate([Prop({
  required: true
})], TrialInfo.prototype, "id", void 0);

__decorate([Prop({
  required: true
})], TrialInfo.prototype, "trialInfo", void 0);

__decorate([Prop({
  required: true,
  default: {
    trialStatus: ''
  }
})], TrialInfo.prototype, "nearestSchedule", void 0);

TrialInfo = __decorate([Component({
  components: {
    VideoIframe: VideoIframe,
    EmptyContent: EmptyContent
  }
})], TrialInfo);
export default TrialInfo;